import type { TimesheetEntry } from "./types"

const DRAFT_ENTRIES_KEY = 'tt_draft_entries'

export function saveDraftEntries(entries: TimesheetEntry[]): void {
  try {
    const serialized = entries.map(entry => ({
      ...entry,
      startTime: typeof entry.startTime === 'string' ? entry.startTime : entry.startTime,
      endTime: entry.endTime ? (typeof entry.endTime === 'string' ? entry.endTime : entry.endTime) : null,
    }))
    localStorage.setItem(DRAFT_ENTRIES_KEY, JSON.stringify(serialized))
  } catch (error) {
    console.error('Failed to save draft entries:', error)
  }
}

export function loadDraftEntries(): TimesheetEntry[] {
  try {
    const stored = localStorage.getItem(DRAFT_ENTRIES_KEY)
    if (!stored) return []
    
    const parsed = JSON.parse(stored)
    return parsed.map((entry: any) => ({
      ...entry,
      startTime: entry.startTime,
      endTime: entry.endTime || null,
    }))
  } catch (error) {
    console.error('Failed to load draft entries:', error)
    return []
  }
}

export function clearDraftEntries(): void {
  try {
    localStorage.removeItem(DRAFT_ENTRIES_KEY)
  } catch (error) {
    console.error('Failed to clear draft entries:', error)
  }
}

export function addDraftEntry(entry: TimesheetEntry): void {
  const existing = loadDraftEntries()
  const updated = [...existing, entry]
  saveDraftEntries(updated)
}

export function updateDraftEntry(entryId: string, updates: Partial<TimesheetEntry>): void {
  const existing = loadDraftEntries()
  const updated = existing.map(entry => 
    entry.id === entryId ? { ...entry, ...updates } : entry
  )
  saveDraftEntries(updated)
}

export function removeDraftEntry(entryId: string): void {
  const existing = loadDraftEntries()
  const updated = existing.filter(entry => entry.id !== entryId)
  saveDraftEntries(updated)
}
